<div>Down</div>
<ng-container *ngIf="{amtDown: (amtDown$ | async), pctDown: (pctDown$ | async)} as results">
    <div class="Vert-15"></div>
    <div>Amount: ${{results.amtDown | number : '1.0-0'}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Percent: {{results.pctDown | number : '1.0-0'}}%</div>
    <div class="Vert-30"></div>
</ng-container>

